import { MissingTranslationHandler, MissingTranslationHandlerParams } from '@ngx-translate/core';
import { NotTranslatedService } from '../services/not-translated.service';

export class MyMissingTranslationHandler implements MissingTranslationHandler {
    constructor(private nts: NotTranslatedService) {}
    handle(params: MissingTranslationHandlerParams) {
        // exception for routes currently
        if (params.key.indexOf('route_') === 0) {
            return params.key;
        }
        this.nts.notTranslated(params.key);
        return '[MISSING]' + params.key;
    }
}
